import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Commodity } from '../types';
import { quickOrderMailto } from '../utils/contact';
interface Props {
  commodity: Commodity;
}
export function CommodityCard({
  commodity
}: Props) {
  return <article className="group flex h-full flex-col border border-hair bg-panel" data-id="element-46" data-mp="1fix3wavx39ga">
      <div className="relative aspect-[4/3] overflow-hidden" data-id="element-47" data-mp="1kii3mniwvlu2">
        <img src={commodity.image} alt={commodity.name} className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" loading="lazy" data-id="element-48" data-mp="16js2mwsz120f" />
        <span className="absolute left-0 top-4 bg-ink/85 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.16em] text-gold-light" data-id="element-49" data-mp="wnfa4295wu79">
          {commodity.grade}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-6" data-id="element-50" data-mp="2r17uiqsxy3u1">
        <h3 className="font-display text-2xl leading-tight text-bone" data-id="element-51" data-mp="2vz9fjh9xgd85">{commodity.name}</h3>
        <p className="mt-2 text-sm text-muted" data-id="element-52" data-mp="2vwvn7g6mtf4a">{commodity.tagline}</p>

        <dl className="mt-5 grid grid-cols-2 gap-x-4 gap-y-3 border-t border-hair pt-5 text-xs" data-id="element-53" data-mp="33jhw27hgu17x">
          <div data-id="element-54" data-mp="2ylgbtj8azvuv">
            <dt className="font-mono uppercase tracking-[0.14em] text-muted/80" data-id="element-55" data-mp="2yjvhnupwiexj">Minimum lot</dt>
            <dd className="mt-1 text-bone" data-id="element-56" data-mp="3da2t3qhhqxoq">{commodity.minOrder}</dd>
          </div>
          <div data-id="element-57" data-mp="38cb00t5415iy">
            <dt className="font-mono uppercase tracking-[0.14em] text-muted/80" data-id="element-58" data-mp="38dvu6hniimga">Monthly capacity</dt>
            <dd className="mt-1 text-bone" data-id="element-59" data-mp="2koaycy69fupl">{commodity.monthlyCapacity}</dd>
          </div>
          <div data-id="element-60" data-mp="2foycafn7qro2">
            <dt className="font-mono uppercase tracking-[0.14em] text-muted/80" data-id="element-61" data-mp="2fpggpzk14c72">Packaging</dt>
            <dd className="mt-1 text-bone" data-id="element-62" data-mp="2tksbg6y6q2nz">{commodity.packaging}</dd>
          </div>
          <div data-id="element-63" data-mp="2pk00985r5np2">
            <dt className="font-mono uppercase tracking-[0.14em] text-muted/80" data-id="element-64" data-mp="2pne1gd2ojqux">Incoterms</dt>
            <dd className="mt-1 text-bone" data-id="element-65" data-mp="8yqqiu6u95aj">{commodity.incoterms}</dd>
          </div>
        </dl>

        <a href={quickOrderMailto(commodity.name)} className="mt-auto inline-flex items-center gap-2 pt-6 text-sm font-semibold text-gold-light transition-colors duration-150 hover:text-gold" data-id="element-66" data-mp="4x586tbjbysy">
          Place an order for {commodity.name.split(' ')[0].toLowerCase()}
          <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-67" data-mp="37lm8wettid6a" />
        </a>
      </div>
    </article>;
}